import WorkspaceTemplateSchema from 'Shared/utils/normalizeJSON/schemas/WorkspaceTemplate.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

import { handleRequestError } from 'Shared/utils/handle-request-error';
import { showNotificationError } from 'Shared/helpers';
import WpToastManager from 'Wpds/components/toast/WpToastManager';

import WorkspaceTemplatesConstants from '../constants/WorkspaceTemplates.constants';
import * as WorkspaceTemplatesAPI from '../api/WorkspaceTemplates.api';

export const fetchWorkspaceTemplatesSuccess = payload => ({
  type: WorkspaceTemplatesConstants.Actions.FETCH_WORKSPACES_TEMPLATES_SUCCESS,
  payload,
});

export const deleteWorkspaceTemplateSuccess = payload => ({
  type: WorkspaceTemplatesConstants.Actions.DELETE_WORKSPACE_TEMPLATE_SUCCESS,
  payload,
});

export const updateWorkspaceTemplateSuccess = payload => ({
  type: WorkspaceTemplatesConstants.Actions.UPDATE_WORKSPACE_TEMPLATE_SUCCESS,
  payload,
});

export const fetchWorkspaceTemplates = params => dispatch => {
  return handleRequestError(WorkspaceTemplatesAPI.fetchWorkspaceTemplates(params))
    .then(response => {
      dispatch(fetchWorkspaceTemplatesSuccess(normalizer(WorkspaceTemplateSchema, response.data)));
    })
    .catch(error => showNotificationError(error));
};

export const updateWorkspaceTemplate = (id, params) => dispatch => {
  return handleRequestError(WorkspaceTemplatesAPI.updateWorkspaceTemplate(id, params))
    .then(response => {
      dispatch(updateWorkspaceTemplateSuccess(normalizer(WorkspaceTemplateSchema, response.data)));
      WpToastManager.success('Template updated');
      return response;
    })
    .catch(error => {
      showNotificationError(error);
      return error.response.data.error;
    });
};

export const deleteWorkspaceTemplate = id => dispatch => {
  return handleRequestError(WorkspaceTemplatesAPI.deleteWorkspaceTemplate(id))
    .then(response => {
      dispatch(deleteWorkspaceTemplateSuccess(normalizer(WorkspaceTemplateSchema, response.data)));
      WpToastManager.success('Template deleted');
      return response;
    })
    .catch(error => {
      showNotificationError(error);
      return error.response.data.error;
    });
};
